/* import __COLOCATED_TEMPLATE__ from './search-header.hbs'; */
import Component from '@glimmer/component';
import { action, getProperties } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { restartableTask } from 'ember-concurrency';
import { validateSchema } from 'sh-www/utils/validators';
import { number, object } from 'yup';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-people-center-search-header';

const SCHEMA = object({
  'max_rate': number()
    .transform((value) => {
      // throw separate error for zero value
      if (value === '' || value === undefined) {
        return null;
      }

      // parse value if present
      const parsedValue = Number.parseFloat(value);
      return Number.isNaN(parsedValue) ? null : parsedValue;
    })
    .nullable()
    .min(10, 'Max rate must be at least 10'),
});

const hasErrors = (errors) => {
  return Object.values(errors).some((error) => error !== undefined);
}

class PeopleCenterSearchHeader extends Component {
  @service('error-tracker') errorTracker;
  @service media;
  @service store;

  @tracked errors = {};

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get isFormDisabled() {
    return this.handleSubmit.isRunning;
  }

  get max_rate() {
    return this.args.searchRequestMaxRate;
  }

  clearFormErrors() {
    this.errors = {};
  }

  @restartableTask
  *handleSubmit(e) {
    e.preventDefault();

    this.clearFormErrors();

    const { fields } = SCHEMA;
    const properties = getProperties(this, Object.keys(fields));

    const [_, validationErrors = {}] = validateSchema(properties, SCHEMA);
    this.errors = validationErrors;

    // force user to fix errors before searching
    if (hasErrors(validationErrors)) {
      return;
    }

    const {
      searchRequestLocation,
      searchRequestMaxRate,
      searchFilterBySaved,
      searchFilterByPastHired,
      selectedServices,
      searchHeaderInputName
    } = this.args;

    yield this.args.handleSearch(
      searchHeaderInputName,
      selectedServices,
      searchRequestLocation,
      searchRequestMaxRate,
      searchFilterBySaved,
      searchFilterByPastHired,
    );
  }
}

export default PeopleCenterSearchHeader;
